import store from "../../../store";
import {
  LanguageSetting,
  normalizeLanguageSettingPayload,
} from "./languageSettingsApi";
import { UPDATE_LANGUAGE_SETTINGS } from "./languageSettingsReducer";

export function updateLanguageSettings(payload: LanguageSetting) {
  return store.dispatch(
    UPDATE_LANGUAGE_SETTINGS(normalizeLanguageSettingPayload(payload))
  );
}